---
de:
  work_items:
    add_attachment: Anhänge hinzufügen
    attachments: Anhänge
    average_cost_per_closed_work_item: Durchschnittliche Kosten pro geschlossener Aufgabe
    average_days_to_close_work_item: ADurchschnittliche Tage bis zum Abschluss der Aufgabe
    budget_cost: Budgetkosten
    closed_tasks: Geschlossene Aufgaben
    closed_work_items: Geschlossene Aufgaben
    due_date: Fälligkeitsdatum
    error_deleting: TBeim Löschen dieses Workitems ist ein Fehler aufgetreten
    filter_responsibles: Verantwortliche filtern
    forecast_cost: Prognosekosten
    history: Historie
    label_in_use: Wird von {count} Aufgabe verwendet. Wenden Sie sich an den Support, um sie zu ändern. | Wird von {count} Aufgaben verwendet. Wenden Sie sich an den Support, um sie zu ändern.
    label_in_use_error:
      one: Dieses Label wird von einer Aufgabe verwendet, daher kann nur der Support es ändern.
      other: Dieses Label wird von %{count} Aufgaben verwendet, daher kann nur der Support es ändern.
    model_name: Aufgabe
    move: Verschieben
    moved_work_item_from: verschobene Aufgabe von
    new_label: Neue Bezeichnung
    no_attachments: Keine  Anhänge
    not_allowed_to_delete: Sie können nur Ihre eigenen Workitems löschen
    number_of_projects: Anzahl der Projekte
    number_of_work_items: Anzahl der Aufgaben
    open_work_items: Offene Aufgaben
    opened_work_item: geöffnete Aufgabe
    project_status: Projektstatus
    reassigned_work_item_from: neu zugewiesene Aufgabe von
    show_closed_tasks: Geschlossene Aufgaben anzeigen
    show_on_hold_tasks: Aufgaben in Warteschleife anzeigen
    show_only_closed_tasks: Nur geschlossene Aufgaben anzeigen
    show_only_on_hold_tasks: Nur Aufgaben in Warteschleife anzeigen
    started_on: Gestartet am
    status:
      closed: Geschlossen
      in_progress: In Bearbeitung
      on_hold: In der Warteschleife
      open: Offen
    sum_total_cost: Gesamtkostenbetrag
    today: Heute
    total_budget_cost: Gesamtbudgetkosten
    total_closed_cost: Gesamtkosten der geschlossenen Aufgabe
    total_closed_cost_by_month: Gesamtkosten der geschlossenen Aufgabe pro Monat
    total_cost_by_month: Gesamtkosten der Aufgabe
    total_in_progress_cost: Gesamtkosten der laufenden Aufgabe
    total_open_cost: Gesamtkosten der offenen Aufgabe
    total_open_cost_by_month: Gesamtkosten der offenen Aufgabe pro Monat
    validations:
      select_power_plant_first: Bitte wählen Sie zuerst ein Kraftwerk aus
    work_item_labels: Aufgabenbeschriftungen
    work_item_total_cost_by_month: Gesamtkosten der Aufgabe pro Monat
    work_items_by_component: Prozentsatz der Aufgabe nach Komponente
    work_items_by_status_by_month: Offene und geschlossene Aufgaben pro Monat
